export default __webpack_public_path__ + "static/media/bussinesplanbhs.3861fba2.pdf";